<template>
  <section class="bg-surface-primary p-16">
    <slot></slot>
  </section>
</template>

<script lang="ts" setup></script>

<style scoped lang="scss"></style>
